import axios from 'axios';

export const changePreferredCultureCode = async (userId: string, cultureCode: string): Promise<void> => {
  try {
    await axios.post('/identity/api/v2/cultureCodes', {
      userId: userId,
      cultureCode
    });
  } catch (e) {
    console.error(`Failed to change culture: ${e.error}`);
  }
};
